import { render } from "./GiantButton.vue?vue&type=template&id=64a1b1bb&scoped=true"
import script from "./GiantButton.vue?vue&type=script&lang=js"
export * from "./GiantButton.vue?vue&type=script&lang=js"

import "./GiantButton.vue?vue&type=style&index=0&id=64a1b1bb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64a1b1bb"

export default script